// The Payout Report tab: the existing payout report plus the Deductions
// Report. Reads a deep-link path (Site Map -> "Deductions Report") on mount,
// the same way InsuranceHub does for its own tabs.
import React, { useEffect, useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PayoutReport from "./PayoutReport";
import DeductionsReport from "./DeductionsReport";
import { consumeNavPath } from "@/lib/adminNav";

const PayoutHub: React.FC = () => {
  const [tab, setTab] = useState("payout-report");

  useEffect(() => {
    const path = consumeNavPath();
    if (path?.[0] === "deductions") setTab("deductions-report");
  }, []);

  return (
    <Tabs value={tab} onValueChange={setTab} className="space-y-4">
      <TabsList>
        <TabsTrigger value="payout-report">Payout Report</TabsTrigger>
        <TabsTrigger value="deductions-report">Deductions Report</TabsTrigger>
      </TabsList>
      <TabsContent value="payout-report" className="m-0">
        <PayoutReport />
      </TabsContent>
      <TabsContent value="deductions-report" className="m-0">
        <DeductionsReport />
      </TabsContent>
    </Tabs>
  );
};

export default PayoutHub;
